import { useAppScopeStore } from '@frontend/scope';
import { useMessagingAIRCustomizationFlag, useVoiceAIRCustomizationFlag } from '@frontend/shared';
import { useAiSettingsAccess } from './use-has-ai-settings-access';

export const useAiReceptionistAccess = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { hasAiSettingsAccess } = useAiSettingsAccess();

  const { isActive: hasTlAiVoiceAccess } = useVoiceAIRCustomizationFlag(selectedLocationIds);
  const { isActive: hasTlAiMessagingAccess } = useMessagingAIRCustomizationFlag(selectedLocationIds);

  const hasAiReceptionistAccess = (hasTlAiVoiceAccess || hasTlAiMessagingAccess) && hasAiSettingsAccess;

  return {
    hasTlAiVoiceAccess,
    hasTlAiMessagingAccess,
    hasAiReceptionistAccess,
  };
};
